<div class="grid">
    <label class="col-9" style="font-size: 18px; font-weight: bold; margin-left: 30px;">App Metrics</label>
    <div class="col" style="margin-top: -10px;">
        <span style="margin-right: 5px;" data-toggle="tooltip" data-placement="top" [title]="rowData.length === 0 ? 'No data to export.' : 'Export Data'">
            <p-button [disabled]="rowData.length === 0" (onClick)="export()"> Export</p-button>
        </span>
        <span style="margin-right: 5px;" data-toggle="tooltip" data-placement="top" [title]="disableReset ? 'No change to reset' : 'Reset page to default'">
            <p-button [disabled]="disableReset" (onClick)="reset()"> Reset</p-button>
        </span>
    </div>
</div>
<div class="grid">
    <div *ngIf="!showSearch" class="col-fixed p-2 border-round-sm" style="width:30px;height:75vh;background-color: lightgray; margin-left: -13px; cursor: pointer; color: black;" (click)="showSearch = true">
        <i class="pi pi-chevron-right"></i>
        <div style="writing-mode: tb-rl;margin-left: -3px; margin-top: 20vh; font-size: 18px;">Search Criteria</div>
    </div>
    <div [style.width]="showSearch ? '500px' : '0px'" [style.height]="showSearch ? '75vh' : '1px'" [style.overflow]="showSearch ? 'visible' : 'hidden'" [style.visibility]="showSearch ? 'visible' : 'hidden'" style="margin-right: 5px;">
        <div class="grid" style="margin-top: 8px;background-color: lightgray; padding: 5px; color: black; border-top-right-radius: 5px;">
            <label style="font-size: 16px; font-weight: bold; margin-right: 250px; margin-top: 5px;">Search Criteria </label>
            <span data-toggle="tooltip" data-placement="top" [title]="SearchHoverText">
                <p-button [disabled]="disableSearch" (onClick)="SearchData()"> Retrieve</p-button>
            </span>
            <i class="pi pi-times-circle" style="cursor: pointer; font-size: 20px; margin-top: 7px; margin-left: 20px;" (click)="showSearch = false"></i>
        </div>
        <div style="background-color: white;padding: 1px;width: 515px;margin-left: -7px; height: 100%;border: 1px solid lightgray; border-bottom-right-radius: 5px; min-height: 520px;">
            <div class="grid" style="margin-top: 5px;">
                <div class="col">
                    <label for="crop" style="margin-right: 5px; color: black;">Crop </label>
                    <p-dropdown id="crop" [options]="crops" [disabled]="metricType === 'allUsers'" [(ngModel)]="selectedCrop" [showClear]="true" (ngModelChange)="changeCrop()" [filter]="true" filterMatchMode="startsWith" optionLabel="Name" placeholder="Select" [style]="{'height': '36px'}" />
                </div>
                <div class="col">
                    <label for="level" style="margin-right: 5px; color: black;">Level </label>
                    <p-dropdown id="level" data-toggle="tooltip" data-placement="top" title="Select Program, Region or EZ" [disabled]="metricType === 'allUsers' || metricType === 'cropCnt'" [options]="levels" [showClear]="true" [(ngModel)]="selectedLevel" (ngModelChange)="changeLevel()" optionLabel="name" placeholder="Select" [style]="{'width':'175px', 'height': '36px'}" />
                </div>
            </div>
            <div class="grid" style="margin-top: 10px;align-items: center;">
                <label style="margin-left: 8px; margin-right: 6px; color: black;" for="include">Include</label>
                <ng-select style="min-width: 270px; max-width: 500px;" [disabled]="metricType === 'allUsers' || metricType === 'cropCnt'" [items]="inclusions" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onLevelSearch" placeholder="Select" bindLabel="code" [(ngModel)]="selectedInclusions">
                    <ng-template ng-option-tmp let-item="item">
                        <div data-toggle="tooltip" data-placement="top" title="{{item.desc}}" style="width: 100%;">{{ item.code }}
                        </div>
                    </ng-template>
                </ng-select>
            </div>
            <div class="grid" style="margin-left: 1px; margin-top: 15px;">
                <label style="margin-right: 27px; margin-top: 5px; color: black;" for="user">User </label>
                <p-dropdown id="user" [disabled]="metricType === 'allUsers' || metricType === 'top10' || metricType === 'otisCnt'" [options]="appUsers" [(ngModel)]="selectedUser" [showClear]="true" [filter]="true" filterMatchMode="startsWith" optionLabel="displayName" placeholder="Select" [style]="{'height': '36px', 'width': '270px'}" />
            </div>
            <div class="grid" style="margin-top: 20px; margin-left: 2px;">
                <label for="beginDate" style="width: 170px; color: black;">Beginning date</label>
                <p-calendar id="beginDate" [(ngModel)]="beginDate" [style]="{'width': '270px'}" [showOnFocus]="false" [showIcon]="true" placeholder="mm/dd/yyyy" 
                [maxDate]="maxDate" [showButtonBar]="true" />
            </div>
            <div class="grid" style="margin-top: 20px; margin-left: 2px;">
                <label for="endDate" style="width: 170px; color: black;">Ending date</label>
                <p-calendar id="endDate" [(ngModel)]="endDate" [style]="{'width': '270px'}" [showOnFocus]="false" [showIcon]="true" placeholder="mm/dd/yyyy"
                [minDate]="beginDate" [maxDate]="maxDate" [showButtonBar]="true" />
            </div>
            <div class="grid" style="margin-left: -5px; margin-top: 10px;">
                <div class="col-4" style="font-weight: bold; color: black;">
                    Metrics for: 
                </div>
                <div class="col">
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="Top 10 Users (transactions)" value="top10" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="All User log ins" value="allUsers" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="Program/EZ/Region Activity" value="activityCnt" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="Crop Activity" value="cropCnt" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="APEX transfer count (in/out)" value="apexCnt" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="OTIS transfer count" value="otisCnt" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="Load Times" value="loadTime" [(ngModel)]="metricType" />
                    </div>
                    <div style="margin-bottom: 5px; color: black;">
                        <p-radioButton label="Coding" value="coding" [(ngModel)]="metricType" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col" *ngIf="rowData.length > 0">
        <ag-grid-angular id="agGrid" 
        style="height: 73vh; width: 100%;" class="ag-theme-balham" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" 
        [animateRows]="true" [rowData]="rowData" [enableRangeSelection]=true
        [gridOptions]="gridOptions" [suppressRowClickSelection]="true" [statusBar]="statusBar" (gridReady)="onGridReady($event)"                      
        [animateRows]="true"></ag-grid-angular>
    </div>
</div>
    
